import { employeeByDuty } from "@/features/modules/stat/modules/employeeByDuty";
import { employeeLastExamination } from "@/features/modules/stat/modules/employeeLastExamination";
import { examinationCounter } from "@/features/modules/stat/modules/examinationCounter";
import { examinationSchedule } from "@/features/modules/stat/modules/examinationSchedule";
import { serviceCounter } from "@/features/modules/stat/modules/serviceCounter";

export const featuresStatModules = [employeeLastExamination, employeeByDuty, examinationCounter, examinationSchedule, serviceCounter];
